import { apiData } from '../../common/dataService';
import { getItem, setItem, zeroSecondTime } from '../../common/utils';
import config from '../../config';

var click = getItem('local', 'click');
if (click) {
  click = JSON.parse(click);
  var clickcontact_volume = click.clickcontact_volume;
  var clickedContacts = click.clickedContacts;
  var taskQuota = click.taskQuota;
  var usedTaskQuota = click.usedTaskQuota;
  var refresh_task_quota_at = click.refresh_task_quota_at || 0;
}
// initial state
const state = {
  userList: [],
  agentList: [],
  mealTypes: [],
  totalCount: 0,
  clickcontact_volume: clickcontact_volume || 0,
  clickedContacts: clickedContacts || 0,
  taskQuota: taskQuota || 0,
  usedTaskQuota: usedTaskQuota || 0,
  refresh_task_quota_at: refresh_task_quota_at || 0 // 刷新任务额度计数时间
};

// getters
const getters = {};

// mutations
const mutations = {
  setUserList(state, payload) {
    state.userList = payload.userList;
    state.totalCount = payload.totalCount;
  },
  setMealTypes(state, payload) {
    state.mealTypes = payload;
  },
  setAgentList(state, payload) {
    state.agentList = payload;
  },
  setClickNum(state, payload) {
    // console.log(state, payload);
    //console.log('setclikcNum : ' + JSON.stringify(payload));
    let taskQuota =
      'taskQuota' in payload ? payload.taskQuota : state.taskQuota;
    let usedTaskQuota =
      'usedTaskQuota' in payload ? payload.usedTaskQuota : state.usedTaskQuota;
    state.taskQuota = taskQuota;
    state.usedTaskQuota = usedTaskQuota;
    let refreshTaskQuotaAt = 0;
    const refresh = 'refresh' in payload;
    if (refresh && 'usedTaskQuota' in payload) {
      // 如果设置了已使用任务次数，时间更新
      refreshTaskQuotaAt = zeroSecondTime();
    }
    if (refresh) {
      delete payload['refresh'];
    }
    state.refresh_task_quota_at = refreshTaskQuotaAt;
    payload.refresh_task_quota_at = refreshTaskQuotaAt;
    if (!payload.clickcontact_volume) {
      state.clickedContacts = state.clickcontact_volume;
      payload = {
        clickedContacts: state.clickedContacts,
        clickcontact_volume: state.clickcontact_volume,
        taskQuota: taskQuota,
        usedTaskQuota: usedTaskQuota,
        refresh_task_quota_at: refreshTaskQuotaAt
      };
      setItem('local', 'click', JSON.stringify(payload));
    } else {
      state.clickcontact_volume = payload.clickcontact_volume;
      if (payload.clickedContacts || payload.clickedContacts == 0) {
        state.clickedContacts = payload.clickedContacts;
      } else {
        payload.clickedContacts = state.clickedContacts;
      }
      payload.taskQuota = taskQuota;
      payload.usedTaskQuota = usedTaskQuota;
      setItem('local', 'click', JSON.stringify(payload));
    }
  }
};

//actions
const actions = {
  async fetchUserList({ commit, dispatch }, data) {
    let res = await apiData('post', 'user/getUserList', data);
    commit('setUserList', res);
  },
  async getMeals({ commit, dispatch }, data) {
    let res = await apiData('get', 'user/getMeals', data);
    commit('setMealTypes', res);
    return res;
  },
  async getUserAgentList({ commit, dispatch }, data) {
    let res = await apiData('get', 'user/getUserAgentList', data);
    commit('setAgentList', res);
  },
  async getClickNum({ commit, dispatch }, data) {
    commit('setClickNum', data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js